export default {
    url: '/tms',
    template: '<manage-permissions-users-list-tms></manage-permissions-users-list-tms>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/list/tms/index.js